import React from "react";
import { IMatch } from "../../../interfaces/intarfaces";
import { useStudentAcceptInvite } from "../../../API/queries/studentApiQueries";
import { useNotifier } from "../../../context/ContextNotifier";
import { MatchStatusEnum } from "../../../utils/constants";
import { RoomStatusBox } from "../../Room/RoomCard";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { useTranslation } from "react-i18next";

export const StudentChatRoomStatus: React.FC<{
  match: IMatch;
  size?: SizeType;
}> = ({ match, size = "middle" }) => {
  const { mutate: acceptInvite, isLoading: isLoadingAcceptInvite } =
    useStudentAcceptInvite();
  const notifier = useNotifier();
  const { t } = useTranslation("chats");
  const handleAccept = () => {
    acceptInvite(
      {
        host_id: match.host_id,
        house_id: match.house_id,
        student_id: match.student_id
      },
      {
        onSuccess: () => {
          notifier.success({
            message: t("studentChatRoomStatus.accepted")
          });
        }
      }
    );
  };

  // Chat request sent
  if (
    match.match_status === MatchStatusEnum.LIKED ||
    match.match_status === MatchStatusEnum.CHATTED
  ) {
    return (
      <RoomStatusBox tooltipText={t("studentChatRoomStatus.notYetInvited")} size={size}>
        {t("studentChatRoomStatus.notYetInvited")}
      </RoomStatusBox>
    );
  }
  if (match.match_status === MatchStatusEnum.INVITED) {
    return (
      <RoomStatusBox
        tooltipText={t("studentChatRoomStatus.sendInvitedToolTip")}
        color="orange"
        onClick={handleAccept}
        isLoading={isLoadingAcceptInvite}
        size={size}
      >
        {t("studentChatRoomStatus.acceptInvite")}

      </RoomStatusBox>
    );
  }
  if (
    match.match_status === MatchStatusEnum.ACCEPTED ||
    match.match_status === MatchStatusEnum.PENDING ||
    match.match_status === MatchStatusEnum.ACTIVE
  ) {
    return (
      <RoomStatusBox
        tooltipText={t("studentChatRoomStatus.yourHomeToolTip")}
        color="blue"
        size={size}
      >
        {t("studentChatRoomStatus.newHome")}
      </RoomStatusBox>
    );
  }
  if (match.match_status === MatchStatusEnum.ARCHIVED) {
    return (
      <RoomStatusBox size={size} tooltipText={t("studentChatRoomStatus.archivedOldHouse")}>
        {t("studentChatRoomStatus.archived")}
      </RoomStatusBox>
    );
  }
  return (
    <RoomStatusBox size={size} tooltipText={t("studentChatRoomStatus.unknown")}>
      {t("studentChatRoomStatus.statusCode")} {match.match_status}
    </RoomStatusBox>
  );
};
